/**
 * PAPAPATTES — Toast discret, reutilisable partout (panier, favoris).
 * Usage : window.ppToast('Ajouté au panier', { type: 'success' });
 * types disponibles : 'success' (vert, panier), 'wishlist' (rose, coeur),
 * 'error' (rouge). Duree par defaut : 2.6s.
 */
(function () {
  function ensureContainer() {
    let c = document.getElementById('pp-toast-container');
    if (!c) {
      c = document.createElement('div');
      c.id = 'pp-toast-container';
      c.setAttribute('aria-live', 'polite');
      c.setAttribute('role', 'status');
      document.body.appendChild(c);
    }
    return c;
  }

  var ICONS = {
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
    wishlist: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.1-4.4-9.6-8.6C.6 8.6 2.5 5 6.1 5c2 0 3.3 1 5.9 4 2.6-3 3.9-4 5.9-4 3.6 0 5.5 3.6 3.7 7.4C19.1 16.6 12 21 12 21z"/></svg>',
    error: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12.5"/><circle cx="12" cy="16" r="0.6" fill="currentColor" stroke="none"/></svg>'
  };

  window.ppToast = function (message, options) {
    options = options || {};
    var type = options.type || 'success';
    var duration = options.duration || 2600;
    var container = ensureContainer();

    var toast = document.createElement('div');
    toast.className = 'pp-toast pp-toast--' + type;
    toast.innerHTML =
      '<span class="pp-toast__icon">' + (ICONS[type] || ICONS.success) + '</span>' +
      '<span class="pp-toast__text"></span>';
    toast.querySelector('.pp-toast__text').textContent = message;

    container.appendChild(toast);

    // Jamais plus de 3 toasts empiles a l'ecran en meme temps
    var all = container.querySelectorAll('.pp-toast');
    if (all.length > 3) {
      all[0].remove();
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('pp-toast--visible');
      });
    });

    var removed = false;
    function remove() {
      if (removed) return;
      removed = true;
      toast.remove();
    }

    setTimeout(function () {
      toast.classList.remove('pp-toast--visible');
      toast.addEventListener('transitionend', remove, { once: true });
      setTimeout(remove, 500); // filet de securite si transitionend ne se declenche pas
    }, duration);
  };
})();
